import CustomModal from '../../modals';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';
import { Box, Button, Typography } from '@mui/material';

/**
 * @heading1: AddMessageBoardModal
 * @paragraph: A modal component for adding a new message board. Uses Formik for form handling
 * and integrates with Redux for message board creation.
 * @param: {boolean} open - Whether the modal is open or not.
 * @param: {function} onClose - Function to close the modal.
 */

const CompanyInfoModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    /**
     * @heading3: Variables
     * @ol:
     * loaders: An object containing the loader details from the Redux store.
     */
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { selectedClient } = useSelector((state: RootState) => state.client);

    return <CustomModal open={open} handleClose={onClose} title="Company Info">
        <Box display="flex" flexDirection="column" gap={2}>
            <Typography variant="subtitle2" color="textSecondary"><b>Customer email:</b> {currentUser?.email}</Typography>
            <Box display="flex">
                <Box width="100%">
                    <Typography variant="subtitle2" color="textSecondary" fontWeight="bold">Company name:</Typography>
                    <Typography variant="subtitle2" color="textSecondary">{selectedClient?.company_name}</Typography>
                </Box>
                <Box width="100%">
                    <Typography variant="subtitle2" color="textSecondary" fontWeight="bold">Stripe ID:</Typography>
                    <Typography variant="subtitle2" color="textSecondary">ads_WdasaWdasdaRds22s</Typography>
                </Box>
            </Box>
            <Button sx={{ display: 'none' }} variant="outlined" color="error" fullWidth>Delete Customer</Button>
        </Box>
    </CustomModal>;
};

export default CompanyInfoModal;